import type { ErrorEvent } from '@sentry/core'
import isAdsError from './filters/isAdsError'
import isAuthError from './filters/isAuthError'
import isChunkError from './filters/isChunkError'

const beforeSend = (event: ErrorEvent): ErrorEvent | null => {
  const shouldIgnoreError = isAdsError(event) || isAuthError(event)
  if (isChunkError(event)) {
    if (typeof window !== 'undefined') {
      const w = window as Window & { errorReload?: boolean }
      if (!w.errorReload) {
        console.log('🚀 ~ event: chunk error', w.errorReload)
        w.errorReload = true
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }
    }
    return null
  }
  if (shouldIgnoreError) {
    return null
  }
  return event
}

export default beforeSend
